import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { ShiftManagementFeatureFlags } from 'modules/shift_management/lib/consts/ShiftManagementFeatureFlags'
import NewLeave from 'modules/timeoff/components/NewLeave'
import { LeavesContextProvider } from 'modules/timeoff/lib/LeavesContextProvider'
import timeoffAllowances from 'modules/timeoff/store/collections/allowances'
import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'
import policyTimelines from 'modules/timeoff/store/collections/timeoffPolicies/policyTimelines'

export interface Props {
  currentEmployee: Employee
  onClose: (year: number) => void
  contractVersions: ContractVersions
  startDate: string
  endDate: string
}

const AddLeaveModal = ({
  currentEmployee,
  contractVersions,
  onClose,
  startDate,
  endDate,
}: Props) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const { loading } = useAsyncData(async () => {
    // If we open the New Leave modal from SM without being in TO page first, the
    // leaveTypes and the allowances that check if leaves are in days or hours are not
    // properly populated and the form doesn't fill properly.
    // We will be able to avoid this once TO finishes the GraphQL migration.
    await leaveTypes.fetch()
    await timeoffAllowances.fetch()
    if (hasFeatureFlag(ShiftManagementFeatureFlags.TIMEOFF_POLICY_TIMELINE)) {
      await policyTimelines.fetch({
        data: {
          employee_id: currentEmployee.id,
        },
      })
    }
  }, [])

  return (
    <LeavesContextProvider>
      <NewLeave
        currentEmployee={currentEmployee}
        onClose={onClose}
        contractVersions={contractVersions}
        loading={loading}
        startDate={startDate}
        endDate={endDate}
        fromShifts
      />
    </LeavesContextProvider>
  )
}

export default observer(AddLeaveModal)
